import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ScreenType } from 'src/app/enums/ScreenType';
import { Visitor } from 'src/app/models/visitor';
import moment from 'moment';

@Component({
  selector: 'app-visitor-details',
  templateUrl: './visitor-details.component.html',
  styleUrls: ['./visitor-details.component.scss'],
})
export class VisitorDetailsComponent {
  @Input() set visitorDetails(val: Visitor) {
    if (val) this.setVisitorDetails(val);
  }
  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  @Output() closeVisitorDetail = new EventEmitter<boolean>();
  showVisitorDetailsForm = this.formbuilder.group({
    firstName: [''],
    lastName: [''],
    email: ['', [Validators.email]],
    phoneNumber: [''],
    visitorAddress: [''],
    visitorID: [''],
    purpose: [''],
    carRegistration: [],
    hostUserId: [''],
    hostEmail: [''],
    hostName: [''],
    profilePicture: [''],
    visitDateTime: [''],
    gender: [''],
    checkIn: [''],
    checkOut: [''],
    identityID: [''],
  });
  screenInfo: ScreenType;
  constructor(private formbuilder: FormBuilder) {}
  test() {}
  setVisitorDetails(val: Visitor) {
    this.showVisitorDetailsForm.reset();
    if (val.checkIn)
      this.showVisitorDetailsForm.controls.checkIn.setValue(
        new Date(val.checkIn).toLocaleString()
      );
    if (val.checkOut)
      this.showVisitorDetailsForm.controls.checkOut.setValue(
        new Date(val.checkOut).toLocaleString()
      );
    this.showVisitorDetailsForm.controls.firstName.setValue(val.firstName);
    this.showVisitorDetailsForm.controls.lastName.setValue(val.lastName);
    this.showVisitorDetailsForm.controls.email.setValue(val.email);
    this.showVisitorDetailsForm.controls.phoneNumber.setValue(val.phoneNumber);
    this.showVisitorDetailsForm.controls.visitorAddress.setValue(
      val.visitorAddress
    );
    this.showVisitorDetailsForm.controls.visitorID.setValue(val.visitorID);
    this.showVisitorDetailsForm.controls.purpose.setValue(val.purpose);
    this.showVisitorDetailsForm.controls.carRegistration.setValue(
      val.carRegistration
    );
    this.showVisitorDetailsForm.controls.hostName.setValue(val.hostName);
    const visitDateTime = new Date(val.visitDateTime + 'Z');
    // this.showVisitorDetailsForm.controls.visitDateTime.setValue(
    //   new Date(val.visitDateTime + 'Z') .toLocaleString()
    // );
    this.showVisitorDetailsForm.controls.visitDateTime.setValue(
      moment(visitDateTime).format('DD/MM/YYYY, h:mm:ss A')
    );
    this.showVisitorDetailsForm.controls.profilePicture.setValue(
      val.profilePicture
    );
    this.showVisitorDetailsForm.controls.identityID.setValue(val.identityID);
  }
  onClose() {
    this.closeVisitorDetail.emit();
  }
  ScreenType = ScreenType;
}
